import React from 'react';

import {
  ChipField,
  ReferenceArrayField,
  SelectField,
  SingleFieldList,
  useGetOne,
  useRecordContext,
} from 'react-admin';

import {
  Box,
  Grid,
  Typography,
} from '@mui/material';

import { isEmpty } from 'lodash';

import resourceNames from '../../../../../constants/resourceNames';
import ruleTypes from '../../../../../constants/ruleTypes';
import { requestTypes, RequestTypes } from '../../../../../constants/requestTypes';
import assignmentTrigger, { assignmentTriggerChoices } from '../../../../../constants/assignmentTrigger';
import { TRANSACTION_TYPES_ASSIGNMENT_TITLE } from '../../../../../constants/transactionTypesAssignment';

const SOURCE = 'transactionTypesAssignment';

const TransactionTypesAssignment = () => {
  const record = useRecordContext();
  const assignment = record?.[SOURCE];

  const hasProcess = record?.ruleType === ruleTypes.REQUEST && !!record?.process;
  const { data: processData } = useGetOne<{
    id: string;
    requestType: RequestTypes;
  }>(resourceNames.PROCESSES, { id: record?.process ?? '' }, { enabled: hasProcess });
  const isEligible = hasProcess && processData?.requestType === requestTypes.TRANSACTION;

  if (!isEligible || !assignment?.assignmentTrigger) return null;

  const isAssigning = [
    assignmentTrigger.ON_EXECUTION,
    assignmentTrigger.ON_TRIGGER,
    assignmentTrigger.ON_PING,
  ].some((trigger) => trigger === assignment.assignmentTrigger);

  return (
    <Grid container spacing={2} size={12}>
      <Grid size={12}>
        <Typography fontWeight="bold" color="black">{TRANSACTION_TYPES_ASSIGNMENT_TITLE}</Typography>
      </Grid>
      <Grid size={12}>
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography variant="label">
            On what event would you like to add or remove transaction types on the transaction?
          </Typography>
          <SelectField
            source={`${SOURCE}.assignmentTrigger`}
            choices={assignmentTriggerChoices}
          />
        </Box>
      </Grid>
      {isAssigning && (
        <Grid container size={12}>
          <Box padding={4} sx={{ backgroundColor: 'greenGray.main', borderRadius: 2 }} width="100%">
            <Grid marginBottom={2} size={12}>
              <Box display="flex" flexDirection="column" gap={2}>
                <Typography variant="label">
                  Specify the transaction types to add to the transaction
                </Typography>
                {isEmpty(assignment.transactionTypesToAdd) ? (
                  <Typography>None</Typography>
                ) : (
                  <ReferenceArrayField
                    emptyText="-"
                    reference={resourceNames.TRANSACTION_TYPES}
                    source={`${SOURCE}.transactionTypesToAdd`}
                  >
                    <SingleFieldList>
                      <ChipField source="name" emptyText="-" />
                    </SingleFieldList>
                  </ReferenceArrayField>
                )}
              </Box>
            </Grid>
            <Grid size={12}>
              <Box display="flex" flexDirection="column" gap={2}>
                <Typography variant="label">
                  Specify the transaction types to remove from the transaction
                </Typography>
                {isEmpty(assignment.transactionTypesToRemove) ? (
                  <Typography>None</Typography>
                ) : (
                  <ReferenceArrayField
                    emptyText="-"
                    reference={resourceNames.TRANSACTION_TYPES}
                    source={`${SOURCE}.transactionTypesToRemove`}
                  >
                    <SingleFieldList>
                      <ChipField source="name" emptyText="-" />
                    </SingleFieldList>
                  </ReferenceArrayField>
                )}
              </Box>
            </Grid>
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default TransactionTypesAssignment;
